import React, {useCallback, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import clsx from 'clsx'
import {Dialog, DialogActions, DialogContent, DialogTitle, Skeleton} from '@mui/material'
import {DateTime} from 'luxon'
import {apphistory, AppState} from '../../store'
import {numberToDisplayString} from '../../common/helpers/number.helpers'
import {monthsAmountDisplayedNames} from '../../common/helpers/helpers'
import useTextContents from '../../hooks/useTextContents'
import {invokeLoadingWithText} from '../../common/invokeLoading'
import {
   IPredefinedOfferDetails,
   IPredefinedOfferDetailsModalProps,
   IPredefinedOfferPageSingleOfferProps
} from './PredefinedOfferPageProps'
import useIsMobile from '../../hooks/useIsMobile'
import Paragraph from "../../components/atoms/Paragraph/Paragraph";
import AppButton from "../../components/atoms/AppButton/AppButton";
import {UI_BUTTON_TYPE} from "../../components/atoms/AppButton/AppButtonProps";
import BackButton from "../../components/atoms/BackButton/BackButton";
import PageHeader from "../../components/atoms/PageHeader/PageHeader";
import {HEADER_LEVEL} from "../../components/atoms/PageHeader/PageHeaderProps";
import { SET_APP_HAS_ERROR } from '../../store/actions/application-actions'

import CheckOfferButton from '../../icons/svg/predefined-offer-check-offer-button.svg'
import RecommendedIcon from '../../icons/svg/predefined-offer-recommended-icon.svg'
import MobileDetailModalHeadingIcon from '../../icons/svg/predefined-offer-modal-details-heading-icon.svg'
import PredefinedOfferDefaultPageContent from './PredefinedOfferDefaultPageContent/PredefinedOfferDefaultPageContent'
import PredefinedOfferPredefinedPeriodsPageContent from './PredefinedOfferPredefinedPeriodsPageContent/PredefinedOfferPredefinedPeriodsPageContent'


import './PredefinedOfferPageStyles.scss'


export const PredefinedOfferDetailsModal = (props: IPredefinedOfferDetailsModalProps) => {
   const isMobileDevice = useIsMobile()
   const { setIsMenuOpen, handleOnDialogConfirm, textContent, isLoading, isMenuOpen, instalmentsAmount, instalments, interestRate, ckdz, paymentDate, requestedAmount } = props

   const handleBackClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      setIsMenuOpen(false);
   }


   return (
       <>
          {
             isMobileDevice ? (
                     <Dialog
                         fullScreen
                         open={isMenuOpen} //Zawsze "otwarty" - komponent Autocomplete steruje pojawianiem się tego komponentu
                         disableEnforceFocus //!!! - Ważne - zapobiega rerenderowaniu się komponentu w nieskończonej pętli
                         disableAutoFocus //!!! - Ważne - zapobiega rerenderowaniu się komponentu w nieskończonej pętli
                         onBlur={event  => {}}
                         onFocus={event => {}}
                         onClose={() => setIsMenuOpen(false)}
                         classes={{
                            root: 'predefined-offer-page-dropdown-menu-outer-wrapper-mobile',
                            paper: 'predefined-offer-page-mobile-confirmation-dialog-wrapper'
                         }}
                     >
                        <DialogTitle classes={{ root: 'predefined-offer-page-mobile-confirmation-dialog-header-wrapper' }} component={'div'}>
                           <BackButton onClick={handleBackClick}
                                       mobile={true} className={'app-modal-back-mobile-button'}>
                              {textContent("buttons.back")}
                           </BackButton>
                        </DialogTitle>
                        <DialogContent className='predefined-offer-page-mobile-confirmation-dialog-content-root'>
                           {isLoading ?
                               <div className='predefined-offer-page-spinner'>
                               <span className="page-main-button-loader-spinner"></span>
                                </div>  :
                           <div className='predefined-offer-page-mobile-confirmation-dialog-content-wrapper'>
                              <img src={MobileDetailModalHeadingIcon} alt="" className='predefined-offer-page-mobile-confirmation-dialog-heading-icon'/>
                              <div className='predefined-offer-page-mobile-confirmation-dialog-heading'>
                                 {<Paragraph align={"center"} >{textContent('predefinedOfferPage.offerDetailsDialog.heading')}</Paragraph>}
                                 <PageHeader level={HEADER_LEVEL.H2}
                                             align={"center"}
                                             title={textContent('predefinedOfferPage.offerDetailsDialog.description')}
                                 />

                              </div>
                              <div className='predefined-offer-page-mobile-confirmation-dialog-offer-details'>
                                 <div>
                                    <h6>{textContent('predefinedOfferPage.offerDetailsDialog.installmentsAmount')}</h6>
                                    <p>{numberToDisplayString(instalmentsAmount, " zł")}</p>
                                 </div>
                                 <div>
                                    <h6>{textContent('predefinedOfferPage.offerDetailsDialog.installments')}</h6>
                                    <p>{monthsAmountDisplayedNames(instalments)}</p>
                                 </div>
                                 <div>
                                    <h6>{textContent('predefinedOfferPage.offerDetailsDialog.interestRate')}</h6>
                                    <p>{numberToDisplayString(interestRate, " %")}</p>
                                 </div>
                                 <div>
                                    <h6>{textContent('predefinedOfferPage.offerDetailsDialog.ckdz')}</h6>
                                    <p>{numberToDisplayString(ckdz, " zł")}</p>
                                 </div>
                                 <div>
                                    <h6>{textContent('predefinedOfferPage.offerDetailsDialog.paymentDate')}</h6>
                                    <p>{DateTime.fromISO(paymentDate).toFormat('dd.MM.yyyy')}</p>
                                 </div>
                              </div>
                              <div className='predefined-offer-page-mobile-confirmation-dialog-offer-summary'>
                                 <p>{textContent('predefinedOfferPage.offerDetailsDialog.requestedAmount')}</p>
                                 <h4>{numberToDisplayString(requestedAmount, " zł")}</h4>
                              </div>
                              <AppButton
                                  type='submit'
                                  isLoading={isLoading}
                                  className='predefined-offer-page-mobile-confirmation-dialog-button'
                                  uiButtonType={UI_BUTTON_TYPE.PRIMARY}
                                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                     setIsMenuOpen(false)
                                     handleOnDialogConfirm()
                                  }}
                              >{textContent("buttons.submit")}</AppButton>
                           </div>
                              }
                        </DialogContent>
                     </Dialog>
                 ) :
                 (
                     <Dialog
                         open={isMenuOpen}
                         disableEnforceFocus
                         disableAutoFocus
                         onBlur={event  => {}}
                         onFocus={event => {}}
                         onClose={() => setIsMenuOpen(false)}
                         classes={{
                            root: 'input-dropdown-menu-outer-wrapper-desktop',
                            paper: 'predefined-offer-page-desktop-confirmation-dialog-wrapper'
                         }}
                     >
                        <div className='predefined-offer-page-desktop-confirmation-dialog-heading'>
                           {<Paragraph align={"center"}>{textContent('predefinedOfferPage.offerDetailsDialog.heading')}</Paragraph>}
                           <PageHeader level={HEADER_LEVEL.H2}
                                       align={"center"}
                                       title={textContent('predefinedOfferPage.offerDetailsDialog.description')}
                           />
                           <img src={MobileDetailModalHeadingIcon} alt="" className='predefined-offer-page-desktop-confirmation-dialog-heading-icon'/>
                        </div>
                        <DialogContent className='predefined-offer-page-desktop-confirmation-dialog-content-root'>
                           { isLoading ?
                               <div className='predefined-offer-page-spinner'>
                                <span className="page-main-button-loader-spinner"></span>
                               </div> :
                               <>
                                   <div className='predefined-offer-page-desktop-confirmation-dialog-offer-details'>
                                  <div>
                                     <h6>{textContent('predefinedOfferPage.offerDetailsDialog.installmentsAmount')}</h6>
                                     <p>{numberToDisplayString(instalmentsAmount, " zł")}</p>
                                  </div>
                                  <div>
                                     <h6>{textContent('predefinedOfferPage.offerDetailsDialog.installments')}</h6>
                                     <p>{monthsAmountDisplayedNames(instalments)}</p>
                                  </div>
                                  <div>
                                     <h6>{textContent('predefinedOfferPage.offerDetailsDialog.interestRate')}</h6>
                                     <p>{numberToDisplayString(interestRate, " %")}</p>
                                  </div>
                                  <div>
                                     <h6>{textContent('predefinedOfferPage.offerDetailsDialog.ckdz')}</h6>
                                     <p>{numberToDisplayString(ckdz, " zł")}</p>
                                  </div>
                                  <div>
                                     <h6>{textContent('predefinedOfferPage.offerDetailsDialog.paymentDate')}</h6>
                                     <p>{DateTime.fromISO(paymentDate).toFormat('dd.MM.yyyy r.')}</p>
                                  </div>
                               </div>
                               <div className='predefined-offer-page-desktop-confirmation-dialog-offer-summary'>
                                  <p>{textContent('predefinedOfferPage.offerDetailsDialog.requestedAmount')}</p>
                                  <h4>{numberToDisplayString(requestedAmount, " zł")}</h4>
                               </div>
                           </>
                           }
                        </DialogContent>
                        <DialogActions className='predefined-offer-page-desktop-confirmation-dialog-action-wrapper-root'>
                           <AppButton
                               uiButtonType={UI_BUTTON_TYPE.PRIMARY}
                               isLoading={isLoading}
                               onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                  setIsMenuOpen(false)
                                  handleOnDialogConfirm()
                               }}
                           >{textContent("buttons.submit")}</AppButton>

                           <BackButton  onClick={handleBackClick}
                                        mobile={false}>
                              {textContent("buttons.back")}
                           </BackButton>
                        </DialogActions>
                     </Dialog>
                 )
          }
       </>
   )
}


export const PredefinedOfferPageSingleOffer = (props: IPredefinedOfferPageSingleOfferProps) => {

   const { textContent, handleOnOfferClick, isRecommended, requestedAmount, instalments, instalmentsAmount, id, isLoading } = props


   if(isLoading) {
      return (
         <div className='predefined-offer-page-single-offer-outer-wrapper'>
            <Skeleton
               key={`predefined-single-offer-skeleton-${ id }`}
               variant="rounded"
               className='predefined-offer-page-single-offer-skeleton-placeholder'
            />
         </div>
      )
   }

   return (
       <div
           className={clsx('predefined-offer-page-single-offer-outer-wrapper', isRecommended && 'recommended-offer-outer-wrapper')}
           onClick={() => {
               if(!isLoading){
                  handleOnOfferClick(id)
               }
           }}
       >
          <div className='predefined-offer-page-single-offer-inner-wrapper'>
             <div className='predefined-offer-page-single-offer-requested-amount'>
                <h6 className='predefined-offer-page-single-offer-item-heading'>{textContent('predefinedOfferPage.singleOfferBox.requestedAmount')}</h6>
                <p className='predefined-offer-page-single-offer-item-value'>{numberToDisplayString(requestedAmount, " zł")}</p>
             </div>
             <div className='predefined-offer-page-single-offer-requested-instalments'>
                <h6 className='predefined-offer-page-single-offer-item-heading'>{textContent('predefinedOfferPage.singleOfferBox.installments')}</h6>
                <p className='predefined-offer-page-single-offer-item-value'>{monthsAmountDisplayedNames(instalments)}</p>
             </div>
             <div className='predefined-offer-page-single-offer-requested-instalmentAmount'>
                <h6 className='predefined-offer-page-single-offer-item-heading'>{textContent('predefinedOfferPage.singleOfferBox.installmentsAmount')}</h6>
                <p className='predefined-offer-page-single-offer-item-value'>{numberToDisplayString(instalmentsAmount, " zł")}</p>
             </div>
             {
                 isRecommended &&  (
                     <div className='recommended-offer-text'>
                        <img src={RecommendedIcon} alt=""/>
                        {textContent('predefinedOfferPage.singleOfferBox.recommended')}
                     </div>
                 )
             }
             <img className='predefined-offer-page-single-offer-requested-check-offer-button' src={CheckOfferButton} alt=">"/>
          </div>
          {isRecommended && <div className='recommended-offer-footer'/> }
       </div>
   )
}

const PredefinedOfferPage = () => {

   const { IS_PREDEFINED_PERIODS_AVAILABLE } = useSelector((state: AppState) => state.applicationState)

   return (
      IS_PREDEFINED_PERIODS_AVAILABLE ? <PredefinedOfferPredefinedPeriodsPageContent /> : <PredefinedOfferDefaultPageContent />       
   )
}

export default PredefinedOfferPage